import React from "react";
import {useCurrentFrame, useVideoConfig, spring, interpolate} from "remotion";
import {SPRINGS} from "../../presets/editing-styles";
import {CLAMP, FONT_STACK} from "../../presets/idv";

// Animated number counter — counts from 0 to target value
export const Counter: React.FC<{
  value: number;
  prefix?: string;
  suffix?: string;
  duration?: number;
  fontSize?: number;
  color?: string;
  format?: boolean;
  delay?: number;
  fontFamily?: string;
  fontWeight?: number;
  springProfile?: keyof typeof SPRINGS;
}> = ({
  value,
  prefix = "",
  suffix = "",
  duration = 60,
  fontSize = 120,
  color = "#ffffff",
  format = true,
  delay = 0,
  fontFamily = FONT_STACK,
  fontWeight = 900,
  springProfile = "smooth",
}) => {
  const frame = useCurrentFrame();
  const {fps} = useVideoConfig();

  // Entrance spring for opacity/scale
  const entrance = spring({
    frame: frame - delay,
    fps,
    config: SPRINGS[springProfile],
  });

  // Count progress — linear ramp over duration frames
  const countProgress = interpolate(
    frame - delay,
    [0, duration],
    [0, 1],
    CLAMP,
  );

  const currentValue = Math.round(value * countProgress);
  const displayValue = format
    ? currentValue.toLocaleString("pt-BR")
    : String(currentValue);

  const opacity = interpolate(entrance, [0, 1], [0, 1], CLAMP);
  const scale = interpolate(entrance, [0, 1], [0.8, 1], CLAMP);

  return (
    <div
      style={{
        opacity,
        transform: `scale(${scale})`,
        fontSize: Math.max(fontSize, 48),
        fontWeight,
        color,
        fontFamily,
        lineHeight: 1,
        textAlign: "center",
        fontVariantNumeric: "tabular-nums",
      }}
    >
      {prefix}
      {displayValue}
      {suffix}
    </div>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
